import React, { useEffect, useState } from "react";
import axios from "axios";
import {Link} from "react-router-dom";

const RoomC = () => {
    const [rooms, setRooms] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_ROOMS;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setRooms(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, []);

    return (
        // <pre>{JSON.stringify(rooms, null, 2)}</pre>

        <div className="row"> {/* Ensure a wrapping parent div */}
            {rooms.map((room, index) => {
                return (
                    <div className="col-md-6 col-xl-4 mb-5" key={index}>
                        <div className="card card-explore">
                            <div className="card-explore__img">
                                <img className="card-img" src={room.image} alt={room.name} />
                            </div>
                            <div className="card-body">
                                <h3 className="card-explore__price">
                                    {room.currency} {room.price} <sub>/ Per {room.shift}</sub>
                                </h3>
                                <p>{room.bed} Bed / {room.guest} Guest</p>
                                <h4 className="card-explore__title">{room.name}</h4>
                                <p>{room.description}</p>
                                <Link className="card-explore__link nav-link" to="/contact">
                                    Book Now <i className="ti-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
        
    );
};

export default RoomC;